import { securedHttpClient } from "@/api/httpClient";

const COURSE = "/expense";
export const getExpenses = (custID: any) =>
  securedHttpClient.get(COURSE, {
    params: {
      customerid: custID,
    },
  });
